import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    select: {
      backgroundColor: '#eceff1',
    },
  }));